import {
  auth,
} from '@/modules/firebase/init';

export function firebaseLogout(): void {
  auth.signOut();
}
